import { Field } from 'formik';
import { FormikRadioGroup } from '@flexinet/ui-components';

const statusOptions = [
    { value: '', label: 'All Statuses' },
    { value: 'Active', label: 'Active' },
    { value: 'Inactive', label: 'Inactive' },
];

export const FilterFormComponent = () => {
    return (
        <Field
            name="status"
            label="Status"
            data={statusOptions}
            component={FormikRadioGroup}
            my="md"
        />
    );
};
